import * as i0 from '@angular/core';
import { Directive, HostBinding, Input } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiPrimary` property. */
function mixinEuiPrimary(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiPrimary = false;
        }
        /** Whether the euiPrimary is disabled or not. */
        get euiPrimary() { return this._euiPrimary; }
        set euiPrimary(value) { this._euiPrimary = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiPrimary ? `${rootClass}--primary` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiSecondary` property. */
function mixinEuiSecondary(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiSecondary = false;
        }
        /** Whether the EuiSecondary is disabled or not. */
        get euiSecondary() { return this._euiSecondary; }
        set euiSecondary(value) { this._euiSecondary = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiSecondary ? `${rootClass}--secondary` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiInfo` property. */
function mixinEuiInfo(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiInfo = false;
        }
        /** Whether the EuiInfo is disabled or not. */
        get euiInfo() { return this._euiInfo; }
        set euiInfo(value) { this._euiInfo = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiInfo ? `${rootClass}--info` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with it's original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiSuccess` property. */
function mixinEuiSuccess(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiSuccess = false;
        }
        /** Whether the EuiSuccess is disabled or not. */
        get euiSuccess() { return this._euiSuccess; }
        set euiSuccess(value) { this._euiSuccess = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiSuccess ? `${rootClass}--success` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiWarning` property. */
function mixinEuiWarning(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiWarning = false;
        }
        /** Whether the EuiWarning is disabled or not. */
        get euiWarning() { return this._euiWarning; }
        set euiWarning(value) { this._euiWarning = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiWarning ? `${rootClass}--warning` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiAccent` property. */
function mixinEuiAccent(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiAccent = false;
        }
        /** Whether the EuiAccent is disabled or not. */
        get euiAccent() { return this._euiAccent; }
        set euiAccent(value) { this._euiAccent = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiAccent ? `${rootClass}--accent` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiDanger` property. */
function mixinEuiDanger(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiDanger = false;
        }
        /** Whether the EuiDanger is disabled or not. */
        get euiDanger() { return this._euiDanger; }
        set euiDanger(value) { this._euiDanger = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiDanger ? `${rootClass}--danger` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiVariant` property. */
function mixinEuiVariant(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiVariant = '';
        }
        /** Whether the EuiVariant is disabled or not. */
        get euiVariant() { return this._euiVariant; }
        set euiVariant(value) {
            super.euiPrimary = (value === 'primary');
            super.euiSecondary = (value === 'secondary');
            super.euiWarning = (value === 'warning');
            super.euiInfo = (value === 'info');
            super.euiSuccess = (value === 'success');
            super.euiDanger = (value === 'danger');
            super.euiAccent = (value === 'accent');
            this._euiVariant = value;
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiDisabled` property. */
function mixinEuiDisabled(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiDisabled = false;
        }
        /** Whether the euiDisabled is disabled or not. */
        get euiDisabled() { return this._euiDisabled; }
        set euiDisabled(value) { this._euiDisabled = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiDisabled ? `${rootClass}--disabled disabled` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiClearable` property. */
function mixinEuiClearable(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiClearable = false;
        }
        /** Whether the euiClearable is disabled or not. */
        get euiClearable() { return this._euiClearable; }
        set euiClearable(value) { this._euiClearable = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiClearable ? `${rootClass}--clearable` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiLoading` property. */
function mixinEuiLoading(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiLoading = false;
        }
        /** Whether the euiLoading is disabled or not. */
        get euiLoading() { return this._euiLoading; }
        set euiLoading(value) { this._euiLoading = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiLoading ? `${rootClass}--loading` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiRounded` property. */
function mixinEuiRounded(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiRounded = false;
        }
        /** Whether the euiRounded is disabled or not. */
        get euiRounded() { return this._euiRounded; }
        set euiRounded(value) { this._euiRounded = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiRounded ? `${rootClass}--rounded` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiOutline` property. */
function mixinEuiOutline(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiOutline = false;
        }
        /** Whether the euiOutline is disabled or not. */
        get euiOutline() { return this._euiOutline; }
        set euiOutline(value) { this._euiOutline = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiOutline ? `${rootClass}--outline` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiCompact` property. */
function mixinEuiCompact(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiCompact = false;
        }
        /** Whether the euiCompact is disabled or not. */
        get euiCompact() { return this._euiCompact; }
        set euiCompact(value) { this._euiCompact = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiCompact ? `${rootClass}--compact` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiResponsive` property. */
function mixinEuiResponsive(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiResponsive = false;
        }
        /** Whether the euiResponsive is disabled or not. */
        get euiResponsive() { return this._euiResponsive; }
        set euiResponsive(value) { this._euiResponsive = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiResponsive ? `${rootClass}--responsive` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `euiHighlighted` property. */
function mixinEuiHighlighted(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiHighlighted = false;
        }
        /** Whether the euiHighlighted is disabled or not. */
        get euiHighlighted() { return this._euiHighlighted; }
        set euiHighlighted(value) { this._euiHighlighted = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiHighlighted ? `${rootClass}--highlighted` : ''
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiSmallSize` property. */
function mixinEuiSmallSize(base = class {
}) {
    // TODO: check if should we remove unused/unnecessary sizes
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiSize2XS = false;
            this._euiSizeXS = false;
            this._euiSizeS = false;
        }
        /** apply extremely small size */
        get euiSize2XS() { return this._euiSize2XS; }
        set euiSize2XS(value) { this._euiSize2XS = coerceBooleanProperty(value); }
        /** apply extra small size */
        get euiSizeXS() { return this._euiSizeXS; }
        set euiSizeXS(value) { this._euiSizeXS = coerceBooleanProperty(value); }
        /** apply small size */
        get euiSizeS() { return this._euiSizeS; }
        set euiSizeS(value) { this._euiSizeS = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiSize2XS ? `${rootClass}--size-2xs` : ``,
                this._euiSizeXS ? `${rootClass}--size-xs` : ``,
                this._euiSizeS ? `${rootClass}--size-s` : ``,
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiMediumSize` property. */
function mixinEuiMediumSize(base = class {
}) {
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiSizeM = false;
        }
        /** apply small size */
        get euiSizeM() { return this._euiSizeM; }
        set euiSizeM(value) { this._euiSizeM = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiSizeM ? `${rootClass}--size-m` : ``,
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

/**
 * @license
 * Copyright European Commission All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-style license that can be
 * found in the LICENSE file at https://ec.europa.eu/info/european-union-public-licence_en
 */
/** Mixin to augment a directive with a `EuiLargeSize` property. */
function mixinEuiLargeSize(base = class {
}) {
    // TODO: check if should we remove unused/unnecessary sizes
    class Mixin extends base {
        constructor(...args) {
            super(...args);
            this._euiSizeL = false;
            this._euiSizeXL = false;
            this._euiSize2XL = false;
            this._euiSize3XL = false;
            this._euiSize4XL = false;
            this._euiSize5XL = false;
        }
        /** apply large size */
        get euiSizeL() { return this._euiSizeL; }
        set euiSizeL(value) { this._euiSizeL = coerceBooleanProperty(value); }
        /** apply extra large size */
        get euiSizeXL() { return this._euiSizeXL; }
        set euiSizeXL(value) { this._euiSizeXL = coerceBooleanProperty(value); }
        /** apply extra extra large size */
        get euiSize2XL() { return this._euiSize2XL; }
        set euiSize2XL(value) { this._euiSize2XL = coerceBooleanProperty(value); }
        /** apply extra extra extra large size */
        get euiSize3XL() { return this._euiSize3XL; }
        set euiSize3XL(value) { this._euiSize3XL = coerceBooleanProperty(value); }
        /** apply extra extra extra extra large size */
        get euiSize4XL() { return this._euiSize4XL; }
        set euiSize4XL(value) { this._euiSize4XL = coerceBooleanProperty(value); }
        /** apply extra extra extra extra extra large size */
        get euiSize5XL() { return this._euiSize5XL; }
        set euiSize5XL(value) { this._euiSize5XL = coerceBooleanProperty(value); }
        getCssClasses(rootClass = '') {
            return [
                super['getCssClasses'] ? super['getCssClasses'](rootClass) : rootClass,
                this._euiSizeXL ? `${rootClass}--size-xl` : ``,
                this._euiSize2XL ? `${rootClass}--size-2xl` : ``,
                this._euiSize3XL ? `${rootClass}--size-3xl` : ``,
                this._euiSize4XL ? `${rootClass}--size-4xl` : ``,
                this._euiSize5XL ? `${rootClass}--size-5xl` : ``,
            ].join(' ').trim();
        }
    }
    // Since we don't directly extend from `base` with its original types, and we instruct
    // TypeScript that `T` actually is instantiatable through `new`, the types don't overlap.
    // This is a limitation in TS as abstract classes cannot be typed properly dynamically.
    return Mixin;
}

function applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
                Object.create(null));
        });
    });
}

const BaseComponentMixinBase = mixinEuiPrimary(mixinEuiSecondary(mixinEuiInfo(mixinEuiSuccess(mixinEuiWarning(mixinEuiDisabled())))));
// export class BaseDirective extends BaseComponentMixinBase {
class BaseDirective {
    constructor() {
        this._euiPrimary = false;
        this._euiSecondary = false;
        this._euiInfo = false;
        this._euiSuccess = false;
        this._euiWarning = false;
        this._euiDanger = false;
        this._euiAccent = false;
        this._euiVariant = '';
        this._euiSize2XS = false;
        this._euiSizeXS = false;
        this._euiSizeS = false;
        this._euiSizeM = false;
        this._euiSizeL = false;
        this._euiSizeXL = false;
        this._euiSize2XL = false;
        this._euiSize3XL = false;
        this._euiSize4XL = false;
        this._euiSize5XL = false;
        this._euiSizeVariant = '';
        this._euiRounded = false;
        this._euiOutline = false;
        this._euiCompact = false;
        this._euiDisabled = false;
        this._euiResponsive = false;
        this._euiHighlighted = false;
        this._euiClearable = false;
        this._euiLoading = false;
    }
    // COLORS
    get euiPrimary() { return coerceBooleanProperty(this._euiPrimary); }
    set euiPrimary(value) { this._euiPrimary = coerceBooleanProperty(value); }
    get euiSecondary() { return this._euiSecondary; }
    set euiSecondary(value) { this._euiSecondary = coerceBooleanProperty(value); }
    get euiInfo() { return this._euiInfo; }
    set euiInfo(value) { this._euiInfo = coerceBooleanProperty(value); }
    get euiSuccess() { return this._euiSuccess; }
    set euiSuccess(value) { this._euiSuccess = coerceBooleanProperty(value); }
    get euiWarning() { return this._euiWarning; }
    set euiWarning(value) { this._euiWarning = coerceBooleanProperty(value); }
    get euiDanger() { return this._euiDanger; }
    set euiDanger(value) { this._euiDanger = coerceBooleanProperty(value); }
    get euiAccent() { return this._euiAccent; }
    set euiAccent(value) { this._euiAccent = coerceBooleanProperty(value); }
    get euiVariant() { return this._euiVariant; }
    set euiVariant(value) {
        this._euiPrimary = (value === 'primary');
        this._euiSecondary = (value === 'secondary');
        this._euiWarning = (value === 'warning');
        this._euiInfo = (value === 'info');
        this._euiSuccess = (value === 'success');
        this._euiDanger = (value === 'danger');
        this._euiAccent = (value === 'accent');
        this._euiVariant = value;
    }
    // SIZES
    get euiSize2XS() { return this._euiSize2XS; }
    set euiSize2XS(value) { this._euiSize2XS = coerceBooleanProperty(value); }
    get euiSizeXS() { return this._euiSizeXS; }
    set euiSizeXS(value) { this._euiSizeXS = coerceBooleanProperty(value); }
    get euiSizeS() { return this._euiSizeS; }
    set euiSizeS(value) { this._euiSizeS = coerceBooleanProperty(value); }
    get euiSizeM() { return this._euiSizeM; }
    set euiSizeM(value) { this._euiSizeM = coerceBooleanProperty(value); }
    get euiSizeL() { return this._euiSizeL; }
    set euiSizeL(value) { this._euiSizeL = coerceBooleanProperty(value); }
    get euiSizeXL() { return this._euiSizeXL; }
    set euiSizeXL(value) { this._euiSizeXL = coerceBooleanProperty(value); }
    get euiSize2XL() { return this._euiSize2XL; }
    set euiSize2XL(value) { this._euiSize2XL = coerceBooleanProperty(value); }
    get euiSize3XL() { return this._euiSize3XL; }
    set euiSize3XL(value) { this._euiSize3XL = coerceBooleanProperty(value); }
    get euiSize4XL() { return this._euiSize4XL; }
    set euiSize4XL(value) { this._euiSize4XL = coerceBooleanProperty(value); }
    get euiSize5XL() { return this._euiSize5XL; }
    set euiSize5XL(value) { this._euiSize5XL = coerceBooleanProperty(value); }
    get euiSizeVariant() { return this._euiSizeVariant; }
    set euiSizeVariant(value) {
        this._euiSize2XS = (value === '2xs');
        this._euiSizeXS = (value === 'xs');
        this._euiSizeS = (value === 's');
        this._euiSizeM = (value === 'm');
        this._euiSizeL = (value === 'l');
        this._euiSizeXL = (value === 'xl');
        this._euiSize2XL = (value === '2xl');
        this._euiSize3XL = (value === '3xl');
        this._euiSize4XL = (value === '4xl');
        this._euiSize5XL = (value === '5xl');
        this._euiSizeVariant = value;
    }
    // EXTRA SHAPES
    get euiRounded() { return this._euiRounded; }
    set euiRounded(value) { this._euiRounded = coerceBooleanProperty(value); }
    get euiOutline() { return this._euiOutline; }
    set euiOutline(value) { this._euiOutline = coerceBooleanProperty(value); }
    get euiCompact() { return this._euiCompact; }
    set euiCompact(value) { this._euiCompact = coerceBooleanProperty(value); }
    // STATES
    get euiDisabled() { return this._euiDisabled; }
    set euiDisabled(value) { this._euiDisabled = coerceBooleanProperty(value); }
    get euiResponsive() { return this._euiResponsive; }
    set euiResponsive(value) { this._euiResponsive = coerceBooleanProperty(value); }
    get euiHighlighted() { return this._euiHighlighted; }
    set euiHighlighted(value) { this._euiHighlighted = coerceBooleanProperty(value); }
    get euiClearable() { return this._euiClearable; }
    set euiClearable(value) { this._euiClearable = coerceBooleanProperty(value); }
    get euiLoading() { return this._euiLoading; }
    set euiLoading(value) { this._euiLoading = coerceBooleanProperty(value); }
    getCssClasses(rootClass) {
        return [
            rootClass,
            this._euiPrimary ? `${rootClass}--primary` : '',
            this._euiSecondary ? `${rootClass}--secondary` : ``,
            this._euiInfo ? `${rootClass}--info` : ``,
            this._euiSuccess ? `${rootClass}--success` : ``,
            this._euiWarning ? `${rootClass}--warning` : ``,
            this._euiDanger ? `${rootClass}--danger` : ``,
            this._euiAccent ? `${rootClass}--accent` : ``,
            this._euiSize2XS ? `${rootClass}--size-2xs` : ``,
            this._euiSizeXS ? `${rootClass}--size-xs` : ``,
            this._euiSizeS ? `${rootClass}--size-s` : ``,
            this._euiSizeM ? `${rootClass}--size-m` : ``,
            this._euiSizeL ? `${rootClass}--size-l` : ``,
            this._euiSizeXL ? `${rootClass}--size-xl` : ``,
            this._euiSize2XL ? `${rootClass}--size-2xl` : ``,
            this._euiSize3XL ? `${rootClass}--size-3xl` : ``,
            this._euiSize4XL ? `${rootClass}--size-4xl` : ``,
            this._euiSize5XL ? `${rootClass}--size-5xl` : ``,
            this._euiRounded ? `${rootClass}--rounded` : ``,
            this._euiOutline ? `${rootClass}--outline` : ``,
            this._euiDisabled ? `${rootClass}--disabled disabled` : ``,
            this._euiCompact ? `${rootClass}--compact` : ``,
            this._euiResponsive ? `${rootClass}--responsive` : ``,
            this._euiHighlighted ? `${rootClass}--highlighted` : ``,
            this._euiClearable ? `${rootClass}--clearable` : ``,
            this._euiLoading ? `${rootClass}--loading` : ``,
            this.styleClass ? this.styleClass : ``,
        ].join(' ').trim();
    }
}
/** @nocollapse */ BaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: BaseDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ BaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: BaseDirective, selector: "[euiBase]", inputs: { e2eAttr: "e2eAttr", styleClass: "styleClass", euiPrimary: "euiPrimary", euiSecondary: "euiSecondary", euiInfo: "euiInfo", euiSuccess: "euiSuccess", euiWarning: "euiWarning", euiDanger: "euiDanger", euiAccent: "euiAccent", euiVariant: "euiVariant", euiSize2XS: "euiSize2XS", euiSizeXS: "euiSizeXS", euiSizeS: "euiSizeS", euiSizeM: "euiSizeM", euiSizeL: "euiSizeL", euiSizeXL: "euiSizeXL", euiSize2XL: "euiSize2XL", euiSize3XL: "euiSize3XL", euiSize4XL: "euiSize4XL", euiSize5XL: "euiSize5XL", euiSizeVariant: "euiSizeVariant", euiRounded: "euiRounded", euiOutline: "euiOutline", euiCompact: "euiCompact", euiDisabled: "euiDisabled", euiResponsive: "euiResponsive", euiHighlighted: "euiHighlighted", euiClearable: "euiClearable", euiLoading: "euiLoading" }, host: { properties: { "attr.aria-disabled": "this._euiDisabled.toString()", "attr.data-e2e": "this.e2eAttr" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: BaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[euiBase]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '[attr.aria-disabled]': 'this._euiDisabled.toString()',
                    },
                }]
        }], propDecorators: { e2eAttr: [{
                type: HostBinding,
                args: ['attr.data-e2e']
            }, {
                type: Input
            }], styleClass: [{
                type: Input
            }], euiPrimary: [{
                type: Input
            }], euiSecondary: [{
                type: Input
            }], euiInfo: [{
                type: Input
            }], euiSuccess: [{
                type: Input
            }], euiWarning: [{
                type: Input
            }], euiDanger: [{
                type: Input
            }], euiAccent: [{
                type: Input
            }], euiVariant: [{
                type: Input
            }], euiSize2XS: [{
                type: Input
            }], euiSizeXS: [{
                type: Input
            }], euiSizeS: [{
                type: Input
            }], euiSizeM: [{
                type: Input
            }], euiSizeL: [{
                type: Input
            }], euiSizeXL: [{
                type: Input
            }], euiSize2XL: [{
                type: Input
            }], euiSize3XL: [{
                type: Input
            }], euiSize4XL: [{
                type: Input
            }], euiSize5XL: [{
                type: Input
            }], euiSizeVariant: [{
                type: Input
            }], euiRounded: [{
                type: Input
            }], euiOutline: [{
                type: Input
            }], euiCompact: [{
                type: Input
            }], euiDisabled: [{
                type: Input
            }], euiResponsive: [{
                type: Input
            }], euiHighlighted: [{
                type: Input
            }], euiClearable: [{
                type: Input
            }], euiLoading: [{
                type: Input
            }] } });

// export * from './mixins';

/**
 * Generated bundle index. Do not edit.
 */

export { BaseComponentMixinBase, BaseDirective };
